import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiauthService } from '../services/apiauth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private router: Router, private apiauthService: ApiauthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
   // return true; //esta linea se elimina, solo es para pruebas

    if (this.apiauthService.loggedIn()) {
      const urlOrigen = state.url.split('?')[0].slice(1);
      //se valida esta url con  el listado en  localStorage.getItem('permisosMenu'); si existe entonces retorna true, de lo contrario retorna false y no deja intresar
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
